import { byPrefixAndName } from '@awesome.me/kit-f089350b06/icons';

const hasRequiredPermissions = ({ requires = [] }, permissionGroups) =>
  requires.every((permissionGroup) => permissionGroups.includes(permissionGroup));

const hasAnyRequiredPermissions = ({ requiresAny = [] }, permissionGroups) =>
  requiresAny.some((permissionGroup) => permissionGroups.includes(permissionGroup));

export default (customerName, { permissionGroups, roles }, owner) =>
  [
    {
      title: 'dashboard.title',
      icon: byPrefixAndName.fas.home,
      to: '/',
      requires: ['tickets.read'],
    },
    {
      icon: byPrefixAndName.fas.user,
      title: customerName,
      to: '/customer',
      items: [
        {
          to: '/customer/details',
          title: 'customer.details',
          requires: ['customer_details.read'],
        },
        {
          to: '/customer/users',
          title: 'users.title',
          requires: ['users.read'],
        },
        {
          to: '/customer/roles',
          title: 'users.roles',
          requires: ['roles.read'],
        },
        {
          to: '/customer/notifications',
          title: 'customer.notifications',
          owner: true,
        },
        {
          to: '/documents',
          title: 'documents.title',
          requires: ['documents.read'],
        },
        {
          to: '/customer/quotes',
          title: 'customer.quotes',
          requires: ['quotes.read'],
        },
      ],
    },
    {
      title: 'tickets.title',
      icon: byPrefixAndName.fas['envelope-open'],
      to: '/tickets',
      requires: ['tickets.read'],
    },
    {
      title: 'order.title',
      icon: byPrefixAndName.fas['shopping-cart'],
      to: '/order',
      items: [
        {
          to: '/order/domains',
          title: 'order.domains',
          requires: ['order_domains.write'],
        },
        {
          to: '/order/certificates',
          title: 'order.certificates',
          requires: ['order_certificates.write'],
        },
      ],
    },
    {
      title: 'services',
      requiresAny: [
        'domains.read',
        'domain_handles.read',
        'certificates.read',
        'dns.read',
        'dns_actions.read',
        'servers.read',
        'apps.read',
        'secrets.read',
      ],
    },
    {
      title: 'domains.title',
      icon: byPrefixAndName.fas.browser,
      to: '/domains',
      items: [
        {
          to: '/domains',
          title: 'overview',
          requires: ['domains.read'],
        },
        {
          to: '/domains/handles',
          title: 'domains.handles',
          requires: ['domain_handles.read'],
        },
      ],
    },
    {
      title: 'certificates.title',
      icon: byPrefixAndName.fas['shield-check'],
      to: '/certificates',
      requires: ['certificates.read'],
    },
    {
      title: 'dns.title',
      icon: byPrefixAndName.fas.globe,
      to: '/dns',
      items: [
        {
          to: '/dns',
          title: 'overview',
          requires: ['dns.read'],
        },
        {
          to: '/dns/actions',
          title: 'dns.bulkActions',
          requires: ['dns_actions.read'],
        },
      ],
    },
    {
      to: '/servers',
      icon: byPrefixAndName.fas.server,
      title: 'servers.title',
      requires: ['servers.read'],
    },
    {
      to: '/apps',
      icon: byPrefixAndName.fas['grid-round'],
      title: 'apps.title',
      requires: ['apps.read'],
    },
    {
      to: '/secrets',
      icon: byPrefixAndName.fas.lock,
      title: 'secrets.title',
      requires: ['secrets.read'],
    },
    {
      title: 'finance.title',
      requiresAny: ['products.read', 'invoices.read'],
    },
    {
      title: 'products.title',
      icon: byPrefixAndName.fas['boxes-stacked'],
      to: '/products',
      requires: ['products.read'],
    },
    {
      to: '/invoices',
      icon: byPrefixAndName.fas['file-invoice-dollar'],
      title: 'finance.invoices',
      requires: ['invoices.read'],
    },
    {
      title: 'security',
      requiresAny: ['secure_messages.read', 'support_tokens.read'],
    },
    {
      to: '/secure_message',
      icon: byPrefixAndName.fas.lock,
      title: 'secure_message',
      requires: ['secure_messages.read'],
    },
    {
      to: '/support_tokens',
      title: 'support_tokens',
      icon: byPrefixAndName.fas.headset,
      requires: ['support_tokens.read'],
    },
    {
      to: '/ip_allowlist',
      title: 'access.ipWhitelist',
      icon: byPrefixAndName.fas['user-shield'],
      owner: true,
    },
    {
      to: '/customer_preferences',
      title: 'access.customerPreferences',
      icon: byPrefixAndName.fas.gear,
      owner: true,
    },
  ]
    .map((group) => {
      if ((!__PRODUCTION__ && roles.includes('developer')) || !group?.items) {
        return group;
      }

      return {
        ...group,
        items: group.items.filter((item) => {
          if (item.owner) {
            return owner;
          }

          return hasRequiredPermissions(item, permissionGroups);
        }),
      };
    })
    .filter((group) => {
      if (!__PRODUCTION__ && roles.includes('developer')) {
        return true;
      }

      if (group?.requiresAny) {
        return hasAnyRequiredPermissions(group, permissionGroups);
      }

      if (group?.requires) {
        return hasRequiredPermissions(group, permissionGroups);
      }

      if (group?.items) {
        return group.items.length > 0;
      }

      if (group?.owner) {
        return owner;
      }

      return true;
    });
